"use client";

import { toast } from "sonner";
import { useTranslations } from "next-intl";

/**
 * Localised confirmation toasts for the bookmark / follow toggles.
 *
 * Two things this exists to prevent:
 *
 * 1. **Double toasts.** The first version called `toast.success(...)` INSIDE a
 *    `setState(prev => …)` updater. React invokes updaters twice under
 *    StrictMode (`reactStrictMode: true` in next.config), so every toggle
 *    raised two identical toasts. Side effects must run outside the updater —
 *    the hooks below are called after the state has been computed.
 * 2. **Hard-coded English.** QA asked for the toast to follow the chosen
 *    locale; the strings live in `messages/*.json` under `toast.*`.
 *
 * Each call raises its OWN toast — no shared `id`. Collapsing them by id meant
 * several quick actions produced a single message, which hid what had actually
 * happened; QA asked for "multiple toast messages, if the user created multiple
 * actions within a very small time".
 */
export function useToggleToast() {
  const t = useTranslations("toast");
  return {
    bookmark: (saved: boolean) =>
      toast.success(t(saved ? "bookmarked" : "unbookmarked")),
    follow: (following: boolean) =>
      toast.success(t(following ? "followed" : "unfollowed")),
  };
}
